import React from "react";
import "./Loader.css";

const Loader = () => {
  return (
    <div className="loader-overlay">
      <div className="loader-content">
        <img src="/favicon.png" alt="Loading..." className="logo-spinner" />
        <p className="loading-text">Loading...</p>
      </div>
    </div>
  );
};

export default Loader;
